import { render, staticRenderFns } from "./model4.vue?vue&type=template&id=29c12841&scoped=true"
import script from "./model4.vue?vue&type=script&lang=js"
export * from "./model4.vue?vue&type=script&lang=js"
import style0 from "./model4.vue?vue&type=style&index=0&id=29c12841&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c12841",
  null
  
)

export default component.exports